import * as React from "react";
import type { SVGProps } from "react";
const SvgThumbsDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 21.01a3 3 0 0 1-3-3v-1a3 3 0 0 0-3-3H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h2a2 2 0 0 1 1.6.8 4 4 0 0 1 2.4-.8h7c1.31-.12 2.56 1 3 2.77l1 5a1 1 0 0 1 0 .19 3 3 0 0 1-3 3h-2v4a3 3 0 0 1-3 3.04m-5-8.9a5 5 0 0 1 4 4.9v1a1 1 0 0 0 2 0v-5a1 1 0 0 1 1-1h3a1 1 0 0 0 1-.92l-1-4.88c-.16-.77-.6-1.2-.92-1.2H10a2 2 0 0 0-2 2zm-4-7.1v7h2v-7z"
    />
  </svg>
);
export default SvgThumbsDown;
